import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redmine-connect',
  templateUrl: './redmine-connect.component.html',
  styleUrls: ['./redmine-connect.component.css']
})
export class RedmineConnectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
